
export const apiConstants = {
  url: "/api/emailLogs"
};
